import * as React from 'react'
import * as TestySDK from 'sdk/testy-web-sdk'
import * as useSWR from 'hooks/swr'
import { AuthContext } from 'providers/auth-provider'

const useDeleteSimulation = (): ((simulationId: string) => void) => {
    const { authData } = React.useContext(AuthContext)
    const { mutate } = useSWR.useSimulations()

    const deleteSimulation = async (simulationId: string) => {
        if (authData?.userUid) await TestySDK.deleteSimulation(authData.userUid, simulationId)
        mutate()
    }

    return deleteSimulation
}

export default useDeleteSimulation
